
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Spedizione } from '@/models';
import dayjs, { Dayjs } from 'dayjs';
import { store, StoreMutations } from '@/store';

@Component
export default class CardSpedizione extends Vue {
    @Prop() public spedizione!: Spedizione;
    @Prop({ default: false }) private compact!: boolean;

    private iconClassByProgress(ord: Spedizione): string {
            return 'grey';
    }

    private formatDate(date: Date): string {
        if (!date) return '';
        return dayjs(date).format('DD/MM/YYYY HH:mm');
    }
    private showDetail() {
        this.$router.push({ name: 'spedizione', params: { id: this.spedizione.id }});
    }

    private apriDDT()
    {
        window.open( 'ddt/' + this.spedizione.id , '_blank');
    }

    public setIdSpedizioneForDelete(id: string | null | undefined){
        store.commit(StoreMutations.SetIdSpedizioneForDelete, id);
    }
}
